import moment from 'moment';

const EARNINGS_CARD_DAY_FORMAT = 'D';
const EARNINGS_CARD_MONTH_FORMAT = 'MMM';
const EARNINGS_CARD_YEAR_FORMAT = 'YYYY';
const DEFAULT_TRUNCATE_SUFFIX = '...';

export type EarningsCardDateParts = {
  isToday: boolean;
  day: string;
  month: string;
  /** The cards omit the year; the calendar rows show it. */
  year: string;
};

/**
 * Earnings cards show "Today", or a stacked day and month with no year.
 */
export const formatEarningsCardDate = (date: string | Date): EarningsCardDateParts => {
  const momentDate = moment(date);
  const today = moment();

  return {
    isToday: today.isSame(momentDate, 'day')
      && today.isSame(momentDate, 'month')
      && today.isSame(momentDate, 'year'),
    day: momentDate.format(EARNINGS_CARD_DAY_FORMAT),
    month: momentDate.format(EARNINGS_CARD_MONTH_FORMAT),
    year: momentDate.format(EARNINGS_CARD_YEAR_FORMAT),
  };
};

export const truncateText = (
  text?: string,
  maxLength?: number,
  suffix = DEFAULT_TRUNCATE_SUFFIX,
): string | undefined => {
  if (!text || maxLength === undefined || text.length <= maxLength) {
    return text;
  }

  if (maxLength <= 0) {
    return '';
  }

  if (maxLength <= suffix.length) {
    return text.slice(0, maxLength);
  }

  const textLengthWithoutSuffix = maxLength - suffix.length;
  return `${text.slice(0, textLengthWithoutSuffix)}${suffix}`;
};

export type EarningsSurpriseColorState = 'positive' | 'negative' | 'neutral';

export const getEarningsSurpriseColorState = (
  surprise: string | number | null | undefined,
): EarningsSurpriseColorState | undefined => {
  if (surprise === null || surprise === undefined || surprise === '') {
    return undefined;
  }

  const numericSurprise = Number(surprise);
  if (Number.isNaN(numericSurprise)) {
    return undefined;
  }

  if (numericSurprise > 0) return 'positive';
  if (numericSurprise < 0) return 'negative';
  return 'neutral';
};
